export default __webpack_public_path__ + "static/media/tool-item-h5-bg4.80818377.png";